//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storeCardVerifierListApi as cardVerifierListApi, storeCardVerifierSaveApi as cardVerifierSaveApi, storeCardVerifierDeleteApi as cardVerifierDeleteApi } from '@/api/distributionStoreCard';
import { checkPermi } from '@/utils/permission';
export default {
  name: 'DistributionScanAuthority',
  data: function data() {
    return {
      loading: false,
      saving: false,
      list: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        keywords: '',
        status: null
      },
      form: {
        phone: '',
        uid: ''
      }
    };
  },
  mounted: function mounted() {
    this.load(1);
  },
  methods: {
    checkPermi: checkPermi,
    load: function load(page) {
      var _this = this;
      if (page) this.query.page = page;
      this.loading = true;
      var params = {
        page: this.query.page,
        limit: this.query.limit
      };
      if (this.query.keywords) params.keywords = this.query.keywords;
      if (this.query.status !== null && this.query.status !== '') params.status = this.query.status;
      cardVerifierListApi(params).then(function (res) {
        var data = res.data || res || {};
        _this.list = data.list || [];
        _this.total = Number(data.total || 0);
      }).catch(function (err) {
        _this.$message.error(err && (err.message || err) || '加载失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    reset: function reset() {
      this.query = {
        page: 1,
        limit: 20,
        keywords: '',
        status: null
      };
      this.load(1);
    },
    onPageChange: function onPageChange(page) {
      this.query.page = page;
      this.load();
    },
    add: function add() {
      var _this2 = this;
      if (!this.form.phone && !this.form.uid) {
        return this.$message.warning('请输入手机号或用户ID');
      }
      this.saving = true;
      // 手机号优先：商户手里一般只有员工手机号，uid 是给内部排查用的兜底
      var data = {
        status: true
      };
      if (this.form.phone) data.phone = this.form.phone;else data.uid = this.form.uid;
      cardVerifierSaveApi(data).then(function () {
        _this2.$message.success('已添加扫码权限');
        _this2.form = {
          phone: '',
          uid: ''
        };
        _this2.load(1);
      }).catch(function (err) {
        _this2.$message.error(err && (err.message || err) || '添加失败');
      }).finally(function () {
        _this2.saving = false;
      });
    },
    toggle: function toggle(row, val) {
      var _this3 = this;
      cardVerifierSaveApi({
        uid: row.uid,
        status: val
      }).then(function () {
        _this3.$message.success(val ? '已开启扫码权限' : '已关闭扫码权限');
      }).catch(function (err) {
        // 失败时把开关拨回去，避免界面和后端状态不一致
        row.status = !val;
        _this3.$message.error(err && (err.message || err) || '操作失败');
      });
    },
    remove: function remove(row) {
      var _this4 = this;
      this.$modalSure("\u786E\u5B9A\u79FB\u9664\u3010".concat(row.nickname || row.uid, "\u3011\u7684\u626B\u7801\u6743\u9650\u5417?")).then(function () {
        cardVerifierDeleteApi(row.uid).then(function () {
          _this4.$message.success('已移除');
          _this4.load(_this4.query.page);
        }).catch(function (err) {
          _this4.$message.error(err && (err.message || err) || '移除失败');
        });
      });
    }
  }
};